import { fetchWithAuth } from '../helpers/fetchWithAuth';
import { getApiUrl } from '../config/api';

const BASE_URL = () => `${getApiUrl()}/api/bank-accounts`;

export interface BankAccount {
  id: number;
  bankName: string;
  accountNumber: string;
  accountHolder: string;
  createdAt?: string;
  updatedAt?: string;
}

const bankAccountService = {
  getAll: async (): Promise<BankAccount[]> => {
    const res = await fetchWithAuth(BASE_URL());
    const data = await res.json();
    return data.success ? data.data : [];
  },

  create: async (payload: Omit<BankAccount, 'id' | 'createdAt' | 'updatedAt'>): Promise<BankAccount> => {
    const res = await fetchWithAuth(BASE_URL(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });
    const data = await res.json();
    if (!data.success) throw new Error(data.message);
    return data.data;
  },

  update: async (id: number, payload: Partial<Omit<BankAccount, 'id' | 'createdAt' | 'updatedAt'>>): Promise<BankAccount> => {
    const res = await fetchWithAuth(`${BASE_URL()}/${id}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });
    const data = await res.json();
    if (!data.success) throw new Error(data.message);
    return data.data;
  },

  delete: async (id: number): Promise<void> => {
    const res = await fetchWithAuth(`${BASE_URL()}/${id}`, { method: 'DELETE' });
    const data = await res.json();
    if (!data.success) throw new Error(data.message);
  },
};

export default bankAccountService;
